import { Component, inject } from '@angular/core';
import { NgForm, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Applications } from 'src/app/interfaces/application';
import { ApplicationsService } from '../applications.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { ScrollbarModule } from '@michelin/theme';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'mic-app-applications-add-modal',
  templateUrl: './applications-add-modal.component.html',
  styleUrls: ['./applications-add-modal.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatDivider,
    ReactiveFormsModule,
    FormsModule,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    ScrollbarModule,
    MatOption,
    MatDialogActions,
    MatButton
  ]
})
export class ApplicationsAddModalComponent {
  dialogRef = inject<MatDialogRef<ApplicationsAddModalComponent>>(MatDialogRef);
  data = inject<Applications>(MAT_DIALOG_DATA);
  private readonly applicationService = inject(ApplicationsService);

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit(f: NgForm) {
    this.applicationService.addApplications(f.value).subscribe((response) => {
      this.dialogRef.close(response);
    });
  }
}
